import { Box } from "@mui/material"
import { ChildCustomerState } from "../../../redux/childCustomer"

type DashboardHeader = {
  childCustomer: ChildCustomerState
}

const DashboardHeader = (props: DashboardHeader) => {
  const { childCustomer } = props
  
  return Boolean(childCustomer.customer_number) && (
    <>
      <Box sx={{ textTransform: 'uppercase', fontSize: '25px' }}>
        {childCustomer.name}
      </Box>
      <Box>
        <Box sx={{ textTransform: 'uppercase' }}>
          {childCustomer.doctor_name} | #{childCustomer.customer_number}
        </Box>
        <Box sx={{ textTransform: 'uppercase' }}>
          {childCustomer.street}, {childCustomer.city}, {childCustomer.state} {childCustomer.zip}
        </Box>
        <Box sx={{ textTransform: 'uppercase' }}>
          {childCustomer.email} | {childCustomer.phone}
        </Box>
      </Box>
    </>
  )
}

export default DashboardHeader
